<template>
    <Card :class="{'mvp-inativo': disabled}" :padding="20"
          :style="{
                marginTop:'10px',
                marginBottom:'10px',
                paddingTop:'15px',
                border: (item.status == 2 && item.andamento == 7 ? '1px solid #5cb85c' : '')
            }"
          shadow
    >
        <template slot="extra">
            <slot name="extra"></slot>
        </template>
        <slot></slot>
        <form-item :label="`Resumo ${item.id_ticket ? `(${item.id_ticket})` : ''}`"
                   :prop="`${ prop }.resumo`"
                   :rules="{required: true, message: required_field, trigger: 'blur'}">
            <i-input placeholder="Resumo" size="large" v-model="item.resumo"></i-input>
        </form-item>
        <form-item
                :prop="`${ prop }.descricao`"
                :rules="{required: true, message: required_field, trigger: 'blur'}"
                label="Descrição">
            <vue-editor :editorToolbar="editorToolbarMin" v-model="item.descricao"></vue-editor>
        </form-item>
        <form-item
                :label="`${item.horas_desenvolvimento} hora${item.horas_desenvolvimento > 1 ? 's' : ''} de desenvolvimento`"
                :prop="`${ prop }.horas_desenvolvimento`">
            <Slider :min="1" show-tip="never" v-model="item.horas_desenvolvimento"></Slider>
        </form-item>
        <form-item
                label="Módulo">
            <i-select @input="(val) => getTreeFunctions(val)" size="large" v-model="item.modulo">
                <i-option :key="i.value" :value="i.value" v-for="i in modulos">
                    {{ i.label }}
                </i-option>
            </i-select>
        </form-item>
        <form-item
                :prop="`${ prop }.funcao`"
                :rules="rulesSelect" label="Função" v-if="functions.length">
            <i-select @input="(val) => getTreeFunctionalities(val)" size="large" v-model="item.funcao">
                <i-option :key="i.value" :value="i.value" v-for="i in functions">
                    {{ i.label }}
                </i-option>
            </i-select>
        </form-item>
        <form-item
                :prop="`${ prop }.funcionalidade`"
                :rules="rulesSelect" label="Funcionalidade" v-if="functionalities.length">
            <i-select size="large" v-model="item.funcionalidade">
                <i-option :key="i.value" :value="i.value" v-for="i in functionalities">
                    {{ i.label }}
                </i-option>
            </i-select>
        </form-item>
        <Row :gutter="30">
            <Card dis-hover>
                <form-item :label="`Pontuação Poker Time: ${ tip[item.poker_time-1] }`"
                        :prop="`${ prop }.poker_time`" >
                    <Slider :max="5" :min="1" show-stops show-tip="never"
                                v-model="item.poker_time"></Slider>
                </form-item>
            </Card>
        </Row>
        <Row :gutter="30">
            <i-col span="24">
                <form-item>
                    <div :key="img_idx" class="lista-imagens"
                         v-for="(imagem, img_idx) in item.imagens.lista">
                        <img :src="imagem.fileUrl">
                        <div class="lista-imagens-cover">
                            <Icon @click.native="visualizarImagem(imagem.fileUrl)"
                                  type="ios-eye-outline"></Icon>
                            <Icon @click.native="removerImagem(img_idx)"
                                  type="ios-trash-outline"></Icon>
                        </div>
                    </div>
                    <vue2-dropzone :id="`dropzone-${ prop }`" :options="{
                                    url: url_upload,
                                    paramName: 'upload[]',
                                    thumbnailWidth: 150,
                                    maxFilesize: 0.5
                                }" :useCustomSlot=true
                                   class="dropzone-imagens"
                                   ref="dropzone"
                                   v-on:vdropzone-success="listarImagens">
                        <Icon size="20" type="ios-camera"></Icon>
                    </vue2-dropzone>
                </form-item>
            </i-col>
        </Row>
        <Modal footer-hide v-model="ver_imagem" width="1024">
            <img :src="url_imagem" alt="Imagem" style="width: 100%" v-if="ver_imagem">
        </Modal>
    </Card>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";
    import {throttle} from 'lodash';
    import {editorToolbarMin} from "../../../helpers/utils.js";
    import treeMixin from '../../../mixins/tree';

    export default {
        components: {
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor),
            vue2Dropzone
        },
        mixins: [treeMixin],
        props: {
            prop: String,
            value: Object,
            modulos: Array,
            disabled: Boolean
        },
        name: "story",
        data() {
            const validatorSelect = (rule, value, callback) => {
                if (value === 0) {
                    callback(new Error(rule.message));
                } else {
                    callback();
                }
            };
            return {
                item: {
                    id_ticket: 0,
                    resumo: "",
                    descricao: "",
                    tela_ux: 0,
                    descricao_tela_ux: "",
                    horas_desenvolvimento: 1,
                    poker_time: 1,
                    esforco: 1,
                    status: 0,
                    andamento: 0,
                    imagens: {
                        lista: [],
                        salvas: [],
                        enviadas: [],
                        removidas: []
                    },
                    modulo: 0,
                    funcao: 0,
                    funcionalidade: 0,
                },
                functions: [],
                functionalities: [],
                tip: ["Muito Baixo", "Baixo", "Médio", "Alto", "Muito Alto"],
                rulesSelect: {
                    required: true,
                    validator: validatorSelect,
                    message: "Este campo não pode ficar vazio",
                    trigger: 'change'
                },
                required_field: "Este campo não pode ficar vazio",
                url_upload: `${process.env.VUE_APP_API_URL}media/image`,
                url_imagem: "",
                ver_imagem: false,
                editorToolbarMin
            }
        },
        methods: {
            visualizarImagem(url) {
                this.url_imagem = url;
                this.ver_imagem = true;
            },
            removerImagem(item_idx) {
                const imagem = this.item.imagens.lista[item_idx];
                if (imagem.temp) {
                    const arquivo = this.dropzone.files[imagem.temp_idx];
                    this.dropzone.removeFile(arquivo);
                } else {
                    this.item.imagens.removidas.push(this.item.imagens.salvas[item_idx]);
                    this.item.imagens.salvas.splice(item_idx, 1);
                }
                this.listarImagens();
            },
            /**
             * Upload de imagens de MVP
             * lista: Todas as imagens para visualização no loop de imagens no DOM
             * salvas: imagens já salvas no Banco de Dados
             * enviadas: imagens upadas em uma pasta temporária
             * removidas: imagens a serem removidas do servidor, quando clicar em salvar
             */
            listarImagens() {
                const imagens_enviadas = this.dropzone.files.map((arq, temp_idx) => {
                    if (arq.xhr && arq.xhr.response) {
                        const response = JSON.parse(arq.xhr.response);
                        if (response.files) {
                            let [arquivo] = response.files;
                            arquivo.temp = true;
                            arquivo.temp_idx = temp_idx;
                            return arquivo;
                        }
                    }
                }).filter(Boolean);

                this.item.imagens.enviadas = imagens_enviadas;
                /**
                 * Concatena as imagens já salvas anteriormente com as que foram enviadas em um unico vetor para visualização
                 */
                this.item.imagens.lista = this.item.imagens.salvas.concat(imagens_enviadas);
            },
            async getTreeFunctions(id) {
                this.functions = await this.getChildren(id);
                if (this.item.funcao
                    && !Array.from(this.functions).map(item => item.value).includes(this.item.funcao)) {
                    this.item.funcao = 0;
                    this.functionalities = [];
                    this.item.funcionalidade = 0;
                } else {
                    this.getTreeFunctionalities(this.item.funcao);
                }
            },
            async getTreeFunctionalities(id) {
                this.functionalities = await this.getChildren(id);
                if (this.item.funcionalidade
                    && !Array.from(this.functionalities).map(item => item.value).includes(this.item.funcionalidade)) {
                    this.item.funcionalidade = 0;
                }
            },
        },
        created() {
            this.item = {
                ...this.item,
                ...this.value
            };
        },
        mounted() {
            this.dropzone = this.$refs.dropzone.dropzone;
        },
        watch: {
            item: {
                handler: throttle(function () {
                    this.$emit("input", this.item);
                }, 100),
                deep: true
            },
            'item.modulo'(val) {
                this.getTreeFunctions(val);
            },
            'item.funcao'(val) {
                this.getTreeFunctionalities(val);
            }
        }
    }
</script>

<style>
    .ivu-upload p {
        text-align: center;
    }

    .mvp-disabled {
        display: none;
    }

    .mvp-inativo {
        position: relative;
    }

    .mvp-inativo .mvp-disabled {
        background-color: #eee9;
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
        cursor: not-allowed;
        border-radius: 4px;
    }

    .mvp-disabled .extra {
        background-color: #f5f5f5;
        position: absolute;
        right: 16px;
        top: 14px;
        transform: rotateY(180deg);
    }
</style>
